<div class="grid-container">
    <div class="grid-x">
        <div class="cell small-12">
            Context Location to Store Parsed APIs:
        </div>
        <div class="cell small-12">
            <input type="text" [(ngModel)]="storeAPIs" />
        </div>
        <p>
            Bulk Well Transfer Parser must be tied to a Flow Data Table component.  It will monitor the 'loaded' node of that component to determine when to activate, in addition to any review form requirements or enabling rules.
            The context value of the Flow Data Table component should be provided, as it was defined in the configuration of the flow data table component (e.g., no '.value').
        </p>
    </div>
</div>